import { Box, Stack, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React from "react";
import { borderColors, grayFontColor } from "../../../cssUtils/constants";
import typography from "../../../cssUtils/typography";

/** Validation issues from the backend; clicking one jumps to the component. */
const IssuesPanel = ({ issues = [], onSelect }) => {
  if (issues.length === 0) return null;
  const errors = issues.filter((i) => i.severity === "error").length;

  return (
    <Box
      sx={{
        mt: 1,
        border: `1px solid ${borderColors.cardBorderPrimaryGrayColor}`,
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Typography sx={{ ...typography.bodyLarge, fontWeight: 600, px: 1.75, py: 1.25 }}>
        {errors > 0
          ? `${errors} ${errors === 1 ? "problem" : "problems"} to fix before publishing`
          : "Suggestions"}
      </Typography>
      <Stack divider={<Box sx={{ borderTop: `1px solid ${borderColors.cardBorderPrimaryGrayColor}` }} />}>
        {issues.map((issue, index) => (
          <Stack
            key={`${issue.code}-${issue.component_id || issue.screen_id || ""}-${index}`}
            direction="row"
            spacing={1}
            alignItems="flex-start"
            component="button"
            type="button"
            onClick={() => onSelect?.(issue)}
            sx={{
              px: 1.75,
              py: 1,
              border: 0,
              background: "none",
              textAlign: "left",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#F8F9FB" },
            }}
          >
            {issue.severity === "error" ? (
              <ErrorOutlineIcon sx={{ fontSize: 18, color: "#b50000", mt: "2px" }} />
            ) : (
              <WarningAmberIcon sx={{ fontSize: 18, color: "#B7791F", mt: "2px" }} />
            )}
            <Typography sx={{ ...typography.bodySmall, color: grayFontColor }}>
              {issue.message}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default IssuesPanel;
